
import { AuditStd_DateRangeRules } from '../../../../core/models/rate-audit-settings-model';
import { DateTime  } from 'typescript-dotnet-es6/System/Time/DateTime'
import { Gregorian } from 'typescript-dotnet-es6/System/Time/Calendars'
import { DateTimeExtension } from './date-time.extension'
import { Property } from './auditstd-edit-model'
import { AddDaysToDate } from '../../../../core'

export class CorporateDateRules {
  public static IsMonthEnabled(dateTime: DateTime, rule: CorporateDateRules.DateSelectionRule): boolean {
    switch (dateTime.month+1) {
      case 1:  return (rule.January);
      case 2:  return (rule.February);
      case 3:  return (rule.March);
      case 4:  return (rule.April);
      case 5:  return (rule.May);
      case 6:  return (rule.June);
      case 7:  return (rule.July);
      case 8:  return (rule.August);
      case 9:  return (rule.September);
      case 10:  return (rule.October);
      case 11:  return (rule.November);
      case 12:  return (rule.December);
    }
    return false;
  }
  static ExtractSeasons(property: Property, dateSelectionRule: CorporateDateRules.DateSelectionRule, displayMessage:boolean): void {
    let startRange = property.Season1StartDate;
    let endRange = property.Season1EndDate;
    //let expectedPrice: number =  parseFloat( property.Season1ExpectedPrice);
    let expectedPrice: number =  ( property.Season1ExpectedPrice);
    let priceDynamic: boolean = property.Season1Dynamic;
    let ceiling: number = property.Season1Ceiling;
    let seasons = new Array<CorporateDateRules.Season>();
    let currentDate: DateTime = startRange;
    if (!CorporateDateRules.IsMonthEnabled(currentDate, dateSelectionRule)){
      currentDate = DateTimeExtension.GetNextEnabledMonth(currentDate,dateSelectionRule);
      if(!CorporateDateRules.IsMonthEnabled(currentDate, dateSelectionRule) || currentDate.toJsDate()>endRange.toJsDate()){
        property.Season1Valid = false;
        return;
      }
    }
    if (displayMessage) {
      property.Information.push( {Message:"Extracting Seasons"})
    }
    let hardEnd = AddDaysToDate(DateTimeExtension.GetFirstDayOfMonth(currentDate).addYears(1),-1);
    if (endRange.toJsDate() > hardEnd.toJsDate())
      endRange = hardEnd;
    for (let i: number = 0; i < 8; i++) {
      let lastSeason: boolean = false;
      let seasonEnd = AddDaysToDate(DateTimeExtension.GetNextEnabledMonth(currentDate, dateSelectionRule), -1);
      if (seasonEnd.toJsDate() >= endRange.toJsDate() || i == 7) {
        seasonEnd = endRange;
        lastSeason = true;
      }
      seasons.push(new CorporateDateRules.Season(currentDate, seasonEnd));
      //console.log("Add Season {0} {1} ", currentDate.toJsDate().toISOString()      , seasonEnd.toJsDate().toISOString()      );
      if (lastSeason)
        break;
      currentDate = DateTimeExtension.GetNextEnabledMonth(currentDate, dateSelectionRule);
    }
    let MaxSeasons: number = 8;

    for (let i: number = 0; i < seasons.length; i++) {
      switch (i + 1) {
        case 1:
          property.Season1StartDate = seasons[i].StartDate;
          property.Season1EndDate = seasons[i].EndDate;
          property.Season1ExpectedPrice = expectedPrice;
          property.Season1Dynamic = priceDynamic;
          property.Season1Valid = true;
          property.Season1Ceiling = ceiling;
          break;
        case 2:
          property.Season2StartDate = seasons[i].StartDate;
          property.Season2EndDate = seasons[i].EndDate;
          property.Season2ExpectedPrice = expectedPrice;
          property.Season2Dynamic = priceDynamic;
          property.Season2Valid = true;
          property.Season2Ceiling = ceiling;
          break;
        case 3:
          property.Season3StartDate = seasons[i].StartDate;
          property.Season3EndDate = seasons[i].EndDate;
          property.Season3ExpectedPrice = expectedPrice;
          property.Season3Dynamic = priceDynamic;
          property.Season3Valid = true;
          property.Season3Ceiling = ceiling;
          break;
        case 4:
          property.Season4StartDate = seasons[i].StartDate;
          property.Season4EndDate = seasons[i].EndDate;
          property.Season4ExpectedPrice = expectedPrice;
          property.Season4Dynamic = priceDynamic;
          property.Season4Valid = true;
          property.Season4Ceiling = ceiling;
          break;
        case 5:
          property.Season5StartDate = seasons[i].StartDate;
          property.Season5EndDate = seasons[i].EndDate;
          property.Season5ExpectedPrice = expectedPrice;
          property.Season5Dynamic = priceDynamic;
          property.Season5Valid = true;
          property.Season5Ceiling = ceiling;
          break;
        case 6:
          property.Season6StartDate = seasons[i].StartDate;
          property.Season6EndDate = seasons[i].EndDate;
          property.Season6ExpectedPrice = expectedPrice;
          property.Season6Dynamic = priceDynamic;
          property.Season6Valid = true;
          property.Season6Ceiling = ceiling;
          break;
        case 7:
          property.Season7StartDate = seasons[i].StartDate;
          property.Season7EndDate = seasons[i].EndDate;
          property.Season7ExpectedPrice = expectedPrice;
          property.Season7Dynamic = priceDynamic;
          property.Season7Valid = true;
          property.Season7Ceiling = ceiling;
          break;
        case 8:
          property.Season8StartDate = seasons[i].StartDate;
          property.Season8EndDate = seasons[i].EndDate;
          property.Season8ExpectedPrice = expectedPrice;
          property.Season8Dynamic = priceDynamic;
          property.Season8Valid = true;
          property.Season8Ceiling = ceiling;
          break;
      }
    }
  }

  public static DoesSeasonContainCheckableDates(seasonId: number, property: Property, DateSelectionRule: CorporateDateRules.DateSelectionRule): boolean {
    let validDateReturned: boolean = false;
    try {
      let seasonValid = true;
      let seasonStart = new DateTime();
      let seasonEnd = new DateTime();
      try {
        switch (seasonId) {
          case 1:
            seasonValid = property.Season1Valid;
            seasonStart = property.Season1StartDate;
            seasonEnd = property.Season1EndDate;
            break;
          case 2:
            seasonValid = property.Season2Valid;
            seasonStart = property.Season2StartDate;
            seasonEnd = property.Season2EndDate;
            break;
          case 3:
            seasonValid = property.Season3Valid;
            seasonStart = property.Season3StartDate;
            seasonEnd = property.Season3EndDate;
            break;
          case 4:
            seasonValid = property.Season4Valid;
            seasonStart = property.Season4StartDate;
            seasonEnd = property.Season4EndDate;
            break;
          case 5:
            seasonValid = property.Season5Valid;
            seasonStart = property.Season5StartDate;
            seasonEnd = property.Season5EndDate;
            break;
          case 6:
            seasonValid = property.Season6Valid;
            seasonStart = property.Season6StartDate;
            seasonEnd = property.Season6EndDate;
            break;
          case 7:
            seasonValid = property.Season7Valid;
            seasonStart = property.Season7StartDate;
            seasonEnd = property.Season7EndDate;
            break;
          case 8:
            seasonValid = property.Season8Valid;
            seasonStart = property.Season8StartDate;
            seasonEnd = property.Season8EndDate;
            break;
        }
      }
      catch (err) {
        seasonValid = false;
      }

      if (seasonValid) {
        let date1: DateTime = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection1, DateSelectionRule.DayInterval1);
        let date2: DateTime = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection2, DateSelectionRule.DayInterval2);
        let date3: DateTime = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection3, DateSelectionRule.DayInterval3);
        let date4: DateTime = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection4, DateSelectionRule.DayInterval4);
        let date5: DateTime = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection5, DateSelectionRule.DayInterval5);
        validDateReturned = !(!date1 && !date2 && !date3 && !date4 && !date5);
      }
    }
    catch (exception) {
      validDateReturned = false;
    }

    return validDateReturned;
  }
  public static ExtractCheckDates(property: Property, DateSelectionRule: CorporateDateRules.DateSelectionRule, reportIssues:boolean): void {
    try {
      property.Season1DateToCheck1 = null;
      property.Season1DateToCheck2 = null;
      property.Season1DateToCheck3 = null;
      property.Season1DateToCheck4 = null;
      property.Season1DateToCheck5 = null;
      property.Season2DateToCheck1 = null;
      property.Season2DateToCheck2 = null;
      property.Season2DateToCheck3 = null;
      property.Season2DateToCheck4 = null;
      property.Season2DateToCheck5 = null;
      property.Season3DateToCheck1 = null;
      property.Season3DateToCheck2 = null;
      property.Season3DateToCheck3 = null;
      property.Season3DateToCheck4 = null;
      property.Season3DateToCheck5 = null;
      property.Season4DateToCheck1 = null;
      property.Season4DateToCheck2 = null;
      property.Season4DateToCheck3 = null;
      property.Season4DateToCheck4 = null;
      property.Season4DateToCheck5 = null;
      property.Season5DateToCheck1 = null;
      property.Season5DateToCheck2 = null;
      property.Season5DateToCheck3 = null;
      property.Season5DateToCheck4 = null;
      property.Season5DateToCheck5 = null;
      property.Season6DateToCheck1 = null;
      property.Season6DateToCheck2 = null;
      property.Season6DateToCheck3 = null;
      property.Season6DateToCheck4 = null;
      property.Season6DateToCheck5 = null;
      property.Season7DateToCheck1 = null;
      property.Season7DateToCheck2 = null;
      property.Season7DateToCheck3 = null;
      property.Season7DateToCheck4 = null;
      property.Season7DateToCheck5 = null;
      property.Season8DateToCheck1 = null;
      property.Season8DateToCheck2 = null;
      property.Season8DateToCheck3 = null;
      property.Season8DateToCheck4 = null;
      property.Season8DateToCheck5 = null;
      for (let i: number = 1; i <= 8; i++) {
        let seasonValid = true;
        let seasonStart = new DateTime();
        let seasonEnd = new DateTime();
        try {
          switch (i) {
            case 1:
              seasonValid = property.Season1Valid;
              seasonStart = property.Season1StartDate;
              seasonEnd = property.Season1EndDate;
              break;
            case 2:
              seasonValid = property.Season2Valid;
              seasonStart = property.Season2StartDate;
              seasonEnd = property.Season2EndDate;
              break;
            case 3:
              seasonValid = property.Season3Valid;
              seasonStart = property.Season3StartDate;
              seasonEnd = property.Season3EndDate;
              break;
            case 4:
              seasonValid = property.Season4Valid;
              seasonStart = property.Season4StartDate;
              seasonEnd = property.Season4EndDate;
              break;
            case 5:
              seasonValid = property.Season5Valid;
              seasonStart = property.Season5StartDate;
              seasonEnd = property.Season5EndDate;
              break;
            case 6:
              seasonValid = property.Season6Valid;
              seasonStart = property.Season6StartDate;
              seasonEnd = property.Season6EndDate;
              break;
            case 7:
              seasonValid = property.Season7Valid;
              seasonStart = property.Season7StartDate;
              seasonEnd = property.Season7EndDate;
              break;
            case 8:
              seasonValid = property.Season8Valid;
              seasonStart = property.Season8StartDate;
              seasonEnd = property.Season8EndDate;
              break;
          }
        }
        catch (err) {
          seasonValid = false;
        }

        if (seasonValid) {
          let date:DateTime[]= [];
          date[0]  = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection1,
            DateSelectionRule.DayInterval1);
          date[1]  = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection2,
            DateSelectionRule.DayInterval2);
          date[2] = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection3,
            DateSelectionRule.DayInterval3);
          date[3] = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection4,
            DateSelectionRule.DayInterval4);
          date[4] = CorporateDateRules.GetSelectedDate(seasonStart, seasonEnd, DateSelectionRule.WeekDaySelection5,
            DateSelectionRule.DayInterval5);
          let dateSorted = date.sort((a:DateTime,b:DateTime) => {return a==null?(b==null?0:1):(b==null?-1:a.compareTo(b))});
          date=[];
          let last:DateTime = null;
          let current:DateTime = null;
          for (let i = 0; i < 5; i++) {
            do{
              current = dateSorted.shift();
            }while(last != null && current!= null && current.compareTo(last)==0)
            last = current;
            date.push(current);
          }
          let validDateReturned = !(!date[0] && !date[1] && !date[2] && !date[3] && !date[4]);
          switch (i) {
            case 1:
              if (validDateReturned) {
                property.Season1DateToCheck1 = date[0];
                property.Season1DateToCheck2 = date[1];
                property.Season1DateToCheck3 = date[2];
                property.Season1DateToCheck4 = date[3];
                property.Season1DateToCheck5 = date[4];
                property.Season1Valid = true;
              }
              else {
                property.Season1Valid = false;
                if(reportIssues){
                  property.Warnings.push( { Message: "Season 1 Date ranges resulted in no dates to check." }); //an empty first month is error
                }
              }
              break;
            case 2:
              if (validDateReturned) {
                property.Season2DateToCheck1 = date[0];
                property.Season2DateToCheck2 = date[1];
                property.Season2DateToCheck3 = date[2];
                property.Season2DateToCheck4 = date[3];
                property.Season2DateToCheck5 = date[4];
                property.Season2Valid = true;
              }
              else {
                property.Season2Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 2 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 3:
              if (validDateReturned) {
                property.Season3DateToCheck1 = date[0];
                property.Season3DateToCheck2 = date[1];
                property.Season3DateToCheck3 = date[2];
                property.Season3DateToCheck4 = date[3];
                property.Season3DateToCheck5 = date[4];
                property.Season3Valid = true;
              }
              else {
                property.Season3Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 3 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 4:
              if (validDateReturned) {
                property.Season4DateToCheck1 = date[0];
                property.Season4DateToCheck2 = date[1];
                property.Season4DateToCheck3 = date[2];
                property.Season4DateToCheck4 = date[3];
                property.Season4DateToCheck5 = date[4];
                property.Season4Valid = true;
              }
              else {
                property.Season4Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 4 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 5:
              if (validDateReturned) {
                property.Season5DateToCheck1 = date[0];
                property.Season5DateToCheck2 = date[1];
                property.Season5DateToCheck3 = date[2];
                property.Season5DateToCheck4 = date[3];
                property.Season5DateToCheck5 = date[4];
                property.Season5Valid = true;
              }
              else {
                property.Season5Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 5 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 6:
              if (validDateReturned) {
                property.Season6DateToCheck1 = date[0];
                property.Season6DateToCheck2 = date[1];
                property.Season6DateToCheck3 = date[2];
                property.Season6DateToCheck4 = date[3];
                property.Season6DateToCheck5 = date[4];
                property.Season6Valid = true;
              }
              else {
                property.Season6Valid = false;

                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 6 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 7:
              if (validDateReturned) {
                property.Season7DateToCheck1 = date[0];
                property.Season7DateToCheck2 = date[1];
                property.Season7DateToCheck3 = date[2];
                property.Season7DateToCheck4 = date[3];
                property.Season7DateToCheck5 = date[4];
                property.Season7Valid = true;
              }
              else {
                property.Season7Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 7 Date ranges resulted in no dates to check." });
                }
              }
              break;
            case 8:
              if (validDateReturned) {
                property.Season8DateToCheck1 = date[0];
                property.Season8DateToCheck2 = date[1];
                property.Season8DateToCheck3 = date[2];
                property.Season8DateToCheck4 = date[3];
                property.Season8DateToCheck5 = date[4];
                property.Season8Valid = true;
              }
              else {
                property.Season8Valid = false;
                if(reportIssues){
                  property.Warnings.push(  { Message: "Season 8 Date ranges resulted in no dates to check." });
                }
              }
              break;
          }
        }
      }
      if (reportIssues && !property.Season1Valid && !property.Season2Valid && !property.Season3Valid && !property.Season4Valid && !property.Season5Valid && !property.Season6Valid && !property.Season7Valid && !property.Season8Valid) {
        property.Errors.push(  { Message: "No Valid Dates were found to check.  All Date ranges resulted in zero checkable dates based on corporate Date rules." });
      }
    }
    catch (exception) {
      let bob: string = "";
      console.log(exception);
    }

  }
  public static NumberOfSeasonsProvided(property: Property): number {
    let seasonCount: number = 0;
    if (property.Season1StartDate != null && property.Season1EndDate != null && property.Season1EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season2StartDate != null && property.Season2EndDate != null && property.Season2EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season3StartDate != null && property.Season3EndDate != null && property.Season3EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season4StartDate != null && property.Season4EndDate != null && property.Season4EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season5StartDate != null && property.Season5EndDate != null && property.Season5EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season6StartDate != null && property.Season6EndDate != null && property.Season6EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season7StartDate != null && property.Season7EndDate != null && property.Season7EndDate!= undefined) {
      seasonCount++;
    }
    if (property.Season8StartDate != null && property.Season8EndDate != null && property.Season8EndDate!= undefined) {
      seasonCount++;
    }
    return seasonCount;
  }
  public static Season1ToBeExtracted(property: Property): boolean {
    return property.Season1StartDate != null && property.Season1EndDate != null && property.Season2StartDate == null && property.Season2EndDate == null && property.Season3StartDate == null && property.Season3EndDate == null && property.Season4StartDate == null && property.Season4EndDate == null;
  }
  public static GetSelectedDate(seasonStart: DateTime, seasonEnd: DateTime, weekDaySelection: Gregorian.DayOfWeek, weekOccurrence: number): DateTime {
    let occurrenceCount: number = 0;
    if (seasonStart && seasonEnd) {
      for (let workingDate: DateTime = seasonStart; workingDate.toJsDate() <= seasonEnd.toJsDate(); workingDate = AddDaysToDate(workingDate,1)) {
        if (workingDate.dayOfWeek == weekDaySelection) {
          occurrenceCount++;
          if (occurrenceCount == weekOccurrence) {
            return workingDate;
          }
        }
      }
    }
    return null;
  }
}

export module CorporateDateRules {
  export class DateSelectionRule {
    public DayInterval1: number;
    public WeekDaySelection1: Gregorian.DayOfWeek;
    public DayInterval2: number;
    public WeekDaySelection2: Gregorian.DayOfWeek;
    public DayInterval3: number;
    public WeekDaySelection3: Gregorian.DayOfWeek;
    public DayInterval4: number;
    public WeekDaySelection4: Gregorian.DayOfWeek;
    public DayInterval5: number;
    public WeekDaySelection5: Gregorian.DayOfWeek;
    public January: boolean;
    public February: boolean;
    public March: boolean;
    public April: boolean;
    public May: boolean;
    public June: boolean;
    public July: boolean;
    public August: boolean;
    public September: boolean;
    public October: boolean;
    public November: boolean;
    public December: boolean;
  }
}
export module CorporateDateRules {
  export class Season {
    constructor(startDate: DateTime, endDate: DateTime) {
      this.StartDate = startDate;
      this.EndDate = endDate;
    }
    public StartDate: DateTime;
    public EndDate: DateTime;
  }
}



export function initDateRangeRules(originalCorporateDateRules:CorporateDateRules.DateSelectionRule, dateRangeRules:AuditStd_DateRangeRules){

  originalCorporateDateRules.DayInterval1 = dateRangeRules.DOW1;
  originalCorporateDateRules.DayInterval2 = dateRangeRules.DOW2;
  originalCorporateDateRules.DayInterval3 = dateRangeRules.DOW3;
  originalCorporateDateRules.DayInterval4 = dateRangeRules.DOW4;
  originalCorporateDateRules.DayInterval5 = dateRangeRules.DOW5;
  var dow1:Gregorian.DayOfWeek, dow2, dow3, dow4, dow5 ;
  originalCorporateDateRules.WeekDaySelection1 = dateRangeRules.DOWIndex1; //dow1;
  originalCorporateDateRules.WeekDaySelection2 = dateRangeRules.DOWIndex2; //dow2;
  originalCorporateDateRules.WeekDaySelection3 = dateRangeRules.DOWIndex3; //dow3;
  originalCorporateDateRules.WeekDaySelection4 = dateRangeRules.DOWIndex4; //dow4;
  originalCorporateDateRules.WeekDaySelection5 = dateRangeRules.DOWIndex5; //dow5;
  //if(dateRangeRules.MonJan != null)
  originalCorporateDateRules.January = dateRangeRules.MonJan;
  //if(dateRangeRules.MonFeb != null)
  originalCorporateDateRules.February = dateRangeRules.MonFeb;
  //if(dateRangeRules.MonMar != null)
  originalCorporateDateRules.March = dateRangeRules.MonMar;
  //if(dateRangeRules.MonApr != null)
  originalCorporateDateRules.April = dateRangeRules.MonApr;
  //if(dateRangeRules.MonMay != null)
  originalCorporateDateRules.May = dateRangeRules.MonMay;
  //if(dateRangeRules.MonJun != null)
  originalCorporateDateRules.June = dateRangeRules.MonJun;
  //if(dateRangeRules.MonJul != null)
  originalCorporateDateRules.July = dateRangeRules.MonJul;
  //if(dateRangeRules.MonAug != null)
  originalCorporateDateRules.August = dateRangeRules.MonAug;
  //if(dateRangeRules.MonSep != null)
  originalCorporateDateRules.September = dateRangeRules.MonSep;
  //if(dateRangeRules.MonOct != null)
  originalCorporateDateRules.October = dateRangeRules.MonOct;
  //if(dateRangeRules.MonNov != null)
  originalCorporateDateRules.November = dateRangeRules.MonNov;
  //if(dateRangeRules.MonDec != null)
  originalCorporateDateRules.December = dateRangeRules.MonDec;
 return {...originalCorporateDateRules}; //clone
}
